import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';
import {Http, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import {environment} from '../../../environments/environment';
import {Pessoa} from './pessoa';
import {SessionService} from './../session/session.service';
import {HeaderService} from './../http/header.service';

@Injectable()
export class PessoaService {

    constructor(private http: Http, private SessionService: SessionService, private HeaderService: HeaderService) {
    }

    validaCpf(cpf: string): Observable<boolean> {
        return this.http
            .get(environment.apiUrl + '/pessoa/valida/cpf/' + cpf)
            .map(res => res.json())
            .catch((err: any) => {
                return Observable.throw(err.json());
            });
    }

    validaPassaporte(passaporte: string): Observable<boolean> {
        return this.http
            .get(environment.apiUrl + '/pessoa/valida/passaporte/' + passaporte)
            .map(res => res.json())
            .catch((err: any) => {
                return Observable.throw(err.json());
            });
    }

    login(pes_cod: string, senha: string): Observable<any> {
        return this.http
            .put(environment.apiUrl + '/pessoa/login',
                {
                    auth: pes_cod,
                    password: senha
                },
                {headers: this.HeaderService.getHeaders()}
            )
            .map(res => res.json())
            .catch((err: any) => {
                return Observable.throw(err.json());
            });
    }

    carregarPessoa(pes_cod: number): Observable<boolean> {
        return this.http
            .get(environment.apiUrl + '/pessoa/' + pes_cod, {headers: this.HeaderService.getHeaders()})
            .map(res => res.json())
            .catch((err: any) => {
                return Observable.throw(err.json());
            });
    }

    getPessoa(): Pessoa {
        const pessoa = this.SessionService.getValor('pessoa');
        if (pessoa) {
            return JSON.parse(pessoa);
        }
        return null;
    }

    setPessoa(pessoa: Pessoa) {
        this.SessionService.setValor('pessoa', JSON.stringify(pessoa));
    }

    salvaPessoa(pessoa: Pessoa): Observable<boolean> {
        if (pessoa.pes_cod) {
            let cep = '';
            if (pessoa.pes_end_cep) {
                cep = pessoa.pes_end_cep.replace('-', '');
            }

            return this.http
                .put(environment.apiUrl + '/pessoa',
                    {
                        pes_cod: pessoa.pes_cod,
                        pes_mail: pessoa.pes_mail,
                        pes_rg_org_exp: pessoa.pes_rg_org_exp,
                        pes_sexo: pessoa.pes_sexo,
                        pes_dat_nas: pessoa.pes_dat_nas,
                        pes_rg: pessoa.pes_rg,
                        pes_rg_uf: pessoa.pes_rg_uf,
                        pes_end_cep: cep,
                        pes_end_rua: pessoa.pes_end_rua,
                        pes_end_num: pessoa.pes_end_num,
                        pes_end_bai: pessoa.pes_end_bai,
                        pes_end_cpl: pessoa.pes_end_cpl,
                        pes_end_cid: pessoa.pes_end_cid,
                        pes_end_uf: pessoa.pes_end_uf,
                        pes_tel_res: pessoa.pes_tel_res,
                        pes_tel_cel: pessoa.pes_tel_cel,
                        cid_cod_end: pessoa.cid_cod_end,
                        uf_cod_rg: pessoa.uf_cod_rg,
                        pes_pass_num: pessoa.pes_pass_num,
                        pes_pass_dat_exp: pessoa.pes_pass_dat_exp,
                        pes_pass_dat_val: pessoa.pes_pass_dat_val,
                        pes_visto_dat_val: pessoa.pes_visto_dat_val,
                        pes_visto_tipo: pessoa.pes_visto_tipo,
                        pes_rne: pessoa.pes_rne,
                    },
                    {headers: this.HeaderService.getHeaders()}
                )
                .map(res => res.json())
                .catch((err: any) => {
                    return Observable.throw(err.json());
                });
        }

        return this.http
            .post(environment.apiUrl + '/pessoa',
                {
                    pes_nom: pessoa.pes_nom,
                    pes_senha: pessoa.pes_senha,
                    pes_senha_confirmation: pessoa.pes_senha_confirmation,
                    pes_dat_nas: pessoa.pes_dat_nas,
                    pes_cpf: pessoa.pes_cpf,
                    pes_sexo: pessoa.pes_sexo,
                    pes_rg: pessoa.pes_rg,
                    pes_rg_org_exp: pessoa.pes_rg_org_exp,
                    pes_rg_uf: pessoa.pes_rg_uf,
                    pes_end_cep: pessoa.pes_end_cep,
                    pes_end_rua: pessoa.pes_end_rua,
                    pes_end_num: pessoa.pes_end_num,
                    pes_end_bai: pessoa.pes_end_bai,
                    pes_end_cpl: pessoa.pes_end_cpl,
                    pes_end_cid: pessoa.pes_end_cid,
                    pes_end_uf: pessoa.pes_end_uf,
                    pes_mail: pessoa.pes_mail,
                    pes_tel_res: pessoa.pes_tel_res,
                    pes_tel_cel: pessoa.pes_tel_cel,
                    uf_cod_rg: pessoa.uf_cod_rg,
                    pes_pass_num: pessoa.pes_pass_num,
                    pes_pass_dat_exp: pessoa.pes_pass_dat_exp,
                    pes_pass_dat_val: pessoa.pes_pass_dat_val,
                    pes_visto_dat_val: pessoa.pes_visto_dat_val,
                    pes_visto_tipo: pessoa.pes_visto_tipo,
                    pes_rne: pessoa.pes_rne,
                    pais_cod_pass: pessoa.pais_cod_pass
                },
                {headers: this.HeaderService.getHeaders()}
            )
            .map(res => {
                pessoa.pes_cod = res.json().pes_cod;
                this.setPessoa(pessoa);
                return res.json();
            })
            .catch((err: any) => {
                return Observable.throw(err.json());
            });
    }

    afterSignin(data) {
        this.SessionService.setValor('token', data.token);
    }

    gravaDadosInscricaoIncompleta(){

        const pessoa = this.getPessoa();

        let cpf     = pessoa.pes_cpf.replace('.', '').replace('.', '').replace('-','');
        let nome    = pessoa.pes_nom +' '+pessoa.pes_sobrenome;
        let email   = pessoa.pes_mail;
        let link = this.SessionService.getValor('processo');
  
        const body = {
            PrcCanIncCpf: cpf,
            PrcIncCanNom: nome,
            PrcCanIncEmail: email,
            PtcCanIncLink: link
        
        };
      
        return this.http.post(environment.apiGxUrl+'/WsPrcInscricaoIncompleta.svc/rest/', body);
    }

    atualizaInscricaoIncompleta(){

        return this.http.post(environment.apiGxUrl+'/WsPrcAtualizaInscIncompleta.svc/rest/',null,{headers: this.HeaderService.getHeadersGnx()});

    } 

}



// WEBPACK FOOTER //
// ./src/app/_shared/pessoa/pessoa.service.ts